/**
 * The detection resource.
 * @author Tony Laurent <t.laurent@apodispharma.com>
 * @param {Object} client - The injected client.
 * @returns {Object} The public object.
 */
export default function (client) {
    return {
        /**
         * Create a detection.
         * @param {string} host - The name of the host.
         * @param {Object} patient - The patient object.
         * @param {boolean} isActive - The detection is active?
         * @param {string} driver  - The detection driver.
         * @returns {Promise} Promise object represents the HTTP request.
         */
        create(host, patient, isActive, driver) {
            return client
                .post('/detections', {
                    data: {
                        first_name: patient.firstName,
                        last_name: patient.lastName,
                        is_active: isActive,
                        birth_date: patient.birthDate,
                        age: patient.age,
                        ... patient.key ? {consumer_key: patient.key} : {},
                    }
                }, {
                    headers: {
                        'X-Host': host,
                        'X-Nir': patient.nir,
                        ... patient.softwareKey ? {'X-Software-Key': patient.softwareKey} : {},
                        'X-Driver': driver
                    }
                })
                .then(response => response.data.data);
        },

        /**
         * Read the detailed detection for the detected customer id.
         *
         * @param {int} customerId
         *
         * @return {Promise<{
         *   consumers: Array<Object>,
         *   memberships: Array<Object>,
         *   certified: Boolean,
         *   certification_status: string,
         *   nextAppointment?: string
         * }>} The array of consumer.
         */
        read(customerId) {
            return client
                .get(`/customers/${customerId}/detection`)
                .then(response => response.data.data);
        }
    };
}
